import type { BaseBodyResponse } from "./interfaces";
import { API_BASE_URL } from "../env";
import { BudgetStatus } from "~/models";

const requestApi = async <T, B = unknown>(
    path: string,
    method: "POST" | "GET" = "GET",
    payload?: B
) => {
    // @TODO: hardcoded temporary
    if (path === "/budgets") {
        return {
            ok: true,
            data: {
                budgets: [
                    {
                        id: "1",
                        status: BudgetStatus.Approved,
                        createdAt: "2023-01-01",
                        name: "Hardware for developers",
                        amount: 565000,
                    },
                    {
                        id: "2",
                        status: BudgetStatus.Pending,
                        createdAt: "2023-02-15",
                        name: "Server, hosting, and domain",
                        amount: 64000,
                    },
                    {
                        id: "3",
                        status: BudgetStatus.Pending,
                        createdAt: "2023-01-01",
                        name: "Office coffee machine",
                        amount: 3000,
                    },
                ],
            },
        } as BaseBodyResponse<T>;
    } else if (path === "/me") {
        return {
            ok: true,
            data: {
                isAuth: true,
                email: "client-portal@gmail.com",
            },
        } as BaseBodyResponse<T>;
    }

    const url = `${API_BASE_URL}${path}`;
    const body = payload ? JSON.stringify(payload) : undefined;
    const response = await fetch(url, {
        method,
        body,
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
        },
    });
    const json = await response.json();

    // @TODO: clean up
    // if (!response.ok) {
    //     throw new Error(json.error);
    // }

    return json as BaseBodyResponse<T>;
};

export default requestApi;
